import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-noauth-layout',
    templateUrl: './noauth-layout.component.html',
    // styles.scss sets `main { overflow-y: scroll }` app-wide, which shows the
    // scrollbar track even when nothing overflows. That keeps the authenticated
    // pages from shifting sideways as you navigate between long and short lists,
    // but the auth screens are a single centred card that always fits.
    styles: [`main { overflow-y: auto; }`],
    standalone: false
})
export class NoauthLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
